import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const UNMATCHED_TRANSACTION_SCHEMA = Object.freeze({
  CLIENT_ID: '',
  TRANSACTION_GUID: '',
  TOTAL_AMOUNT: 0,
  UNMATCHED_AMOUNT: 0,
  CREATED_TIMESTAMP: '',
  CURRENCY_CODE: '',
});
const RECORD = generateSchema(UNMATCHED_TRANSACTION_SCHEMA);
const KEYS: any = generateKeys(UNMATCHED_TRANSACTION_SCHEMA);

export class UnmatchedTransaction extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get clientId(): string {
    return this.get(KEYS.CLIENT_ID);
  }

  get transactionGuid(): string {
    return this.get(KEYS.TRANSACTION_GUID);
  }

  get totalAmount(): number {
    return this.get(KEYS.TOTAL_AMOUNT);
  }

  get unmatchedAmount(): number {
    return this.get(KEYS.UNMATCHED_AMOUNT);
  }

  get currencyCode(): string {
    return this.get(KEYS.CURRENCY_CODE);
  }

  get createdTimestamp(): string {
    return this.get(KEYS.CREATED_TIMESTAMP);
  }
}
